import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useMatch } from "react-router-dom";
import {
  setNav,
} from "../../reducers/appSlice";
import {
  getTournament,
  getTournamentPointOfContact,
  selectCurrentTournament,
  selectLoading,
} from "../../reducers/tournamentSlice";
import "./tournament-details.scss";
import { GSButton, GSEmptyList } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useIntercom } from "react-use-intercom";
import { usePermissions } from "../../hooks/permissionHooks";

const TournamentDetail = (props) => {
  const dispatch = useDispatch();
  const match = useMatch("/:tournamentID/*");
  const currentTournament = useSelector(selectCurrentTournament);
  const loading = useSelector(selectLoading);
  const {userHasAccess} = usePermissions()

  const intercom = useIntercom();

  useEffect(() => {
    dispatch(getTournament(match.params.tournamentID));
  }, [dispatch, match.params.tournamentID]);

  useEffect(() => {
    if (
      currentTournament?.id &&
      currentTournament.pointOfContact === undefined
    ) {
      dispatch(getTournamentPointOfContact(currentTournament?.id));
    }
  }, [dispatch, currentTournament?.id, currentTournament?.pointOfContact]);

  useEffect(() => {
    let nav = [];
    if (userHasAccess) {
      nav = [
        {
          id: 1,
          label: (
            <GSButton
              type="secondary"
              title="All tournaments"
              buttonIcon={faChevronLeft}
            />
          ),
          url: `/`,
          isSelectable: true,
        },
        {
          id: 2,
          label: currentTournament.name,
          isSelectable: false,
          type: "bold",
        },
        {
          id: 3,
          label: "Overview",
          url: `/${currentTournament.id}`,
          isSelectable: true,
        },
        {
          id: 4,
          label: "Rounds & Scorecards",
          url: `/${currentTournament.id}/rounds`,
          isSelectable: true,
        },
        {
          id: 7,
          label: "Event Site & Packages",
          url: `/${currentTournament.id}/promotion`,
          isSelectable: true,
        },
        {
          id: 5,
          label: "Players & Teams",
          url: `/${currentTournament.id}/teams`,
          isSelectable: true,
        },
        {
          id: 6,
          label: "Sponsors",
          url: `/${currentTournament.id}/sponsors`,
          isSelectable: true,
        },
        {
          id: 8,
          label: "Flights",
          url: `/${currentTournament.id}/flighting`,
          isSelectable: true,
        },
        {
          id: 9,
          label: "Leaderboards & Skins",
          url: `/${currentTournament.id}/leaderboards`,
          isSelectable: true,
        },
        {
          id: 9,
          label: "Documents",
          url: `/${currentTournament.id}/documents`,
          isSelectable: true,
        },
        {
          id: 10,
          label: "Orders & Payouts",
          url: `/${currentTournament.id}/reporting`,
          isSelectable: true,
        },
        {
          id: 11,
          label: "Messages",
          url: `/${currentTournament.id}/messages`,
          isSelectable: true,
        },
        {
          id: 12,
          label: "Revenue Enhancements",
          url: `${process.env.REACT_APP_GOLFSTATUS_EVENTS_BASE_URL}/event/revenue-enhancements/register`,
          isExternal: true,
          isSelectable: true,
        },
        {
          id: 13,
          label: "Settings & Preferences",
          url: `/${currentTournament.id}/settings`,
          isSelectable: true,
        },
        {
          id: 14,
          label: "Knowledge Base",
          url: "https://golfstatus.stonly.com/kb/en",
          isExternal: true,
          isSelectable: true,
        },
      ];
    }

    dispatch(setNav(nav));
  }, [currentTournament, dispatch, userHasAccess]);

  const contactGolfStatus = () => {
    intercom.show();
  };

  if (userHasAccess || loading?.length > 0) {
    return (
      <tournament-detail>
        <Outlet></Outlet>
      </tournament-detail>
    );
  }
  return (
    <tournament-detail>
      <GSEmptyList
        title={<center>{`Your organization does not currently have access to ${currentTournament.name}.`}</center>}
        detail={<center>If you think this is a mistake or need help getting access, we're here to help.</center>}
        actions={[
          {
            title: "Contact Golfstatus",
            onClick: contactGolfStatus,
            type: "black",
          },
        ]}
      />
    </tournament-detail>
  );
};

export default TournamentDetail;
